
import { HEATER_CALCULATOR_PATH } from "@/utils/heaterCalculator";

export default {
  data() {
    return {
      path: HEATER_CALCULATOR_PATH,
    };
  },
};
